import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataYAxisValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                title: {
                    type: 'object',
                    empty: false,
                    mandatory: false
                },
                gridLineWidth: {
                    type: 'number',
                    empty: false,
                    mandatory: false
                },
                tickInterval: {
                    type: 'number',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
